import { Trans } from "@lingui/react/macro";
import { observer } from "mobx-react-lite";
import { useState } from "react";

import { apiGetHfComorbiditiesPatientId } from "../../../api";
import { AppModel } from "../../../app/app-model";
import { Button } from "../../../components/ui-kit/button";
import { Dialog } from "../../../components/ui-kit/dialog";
import { useFetch } from "../../../utils/use-fetch";
import { AddDiags } from "../diagnoses/add-diags";
import { AddDiagsTable } from "../diagnoses/add-diags-table";
import { DiagnosesItem } from "../diagnoses/diagnoses";
import { DiagnosesTable } from "../diagnoses/diagnoses-table";
import { Patient } from "../patient";

export const VisitComorbiditiesSection = observer(
  function VisitComorbiditiesSection(props: {
    app: AppModel;
    patient: Patient;
    onSaved?: () => void | Promise<void>;
  }) {
    const { app, patient, onSaved } = props;
    const [data, setData] = useState<DiagnosesItem[]>([]);
    const [addModel, setAddModel] = useState<AddDiags | null>(null);

    const { refetch } = useFetch(
      async ({ isRefetch }) => {
        const response = await apiGetHfComorbiditiesPatientId({
          path: { patient_id: patient.patientId },
          meta: { useSessionCache: !isRefetch },
        });
        setData(response.data.diagnoses);
      },
      [patient.patientId],
    );

    function openAdd() {
      const m = new AddDiags(patient.api, patient);
      m.addItem();
      setAddModel(m);
    }

    return (
      <div className="mb-4">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm font-semibold">
            <Trans>Current comorbidities</Trans>
          </span>
          <Button variant="subtle" onClick={openAdd}>
            <Trans>+ Add comorbidity</Trans>
          </Button>
        </div>

        <DiagnosesTable
          api={patient.api}
          patient={patient}
          data={data}
          disableEdit
          disableHistory
          disablePagination
        />

        <Dialog
          open={addModel != null}
          onOpenChange={(open) => {
            if (!open) setAddModel(null);
          }}
        >
          {addModel && (
            <AddDiagsTable
              app={app}
              model={addModel}
              onSaved={() => {
                setAddModel(null);
                void refetch();
                void onSaved?.();
              }}
            />
          )}
        </Dialog>
      </div>
    );
  },
);
